import React from 'react';

import { useTranslations } from '~src/commons/utils/translations/translate';

import { Label } from '../../api/api';
import { CategoryExtensionProps } from '../category/category-manager';
import { Separator } from '../ui/separator';
import { LabelComponent } from './label/label-component';
import { SwanLabelComponent } from './label/swan-label-component';

export const labelSortFunction = (a: Label, b: Label): number => {
  return (
    Number(b.type === 'LABEL_TYPE_SUSTAINABILITY') - Number(a.type === 'LABEL_TYPE_SUSTAINABILITY')
  );
};

export const LabelExtension: React.FC<CategoryExtensionProps> = ({
  category,
  selectedOption,
  selected,
}) => {
  const { tICU } = useTranslations();

  const sortedLabels = Array.from(category.labels || []).sort(labelSortFunction);

  /*
   * If the category requires customer number, we handle it as a label.
   */
  if (selectedOption.flags.show_customer_number) {
    sortedLabels.push({
      name: tICU('widget.CUSTOMER_NUMBER_INACTIVE'),
      description: '', // description seems to be empty string not undefined when not present.
      type: 'custom',
    });
  }

  if (sortedLabels.length === 0) {
    return null;
  }

  const labelElements = sortedLabels.map((label: Label, idx: number) =>
    label.type === 'LABEL_TYPE_SWAN' ? (
      <SwanLabelComponent key={idx} selected={selected} />
    ) : (
      <LabelComponent
        key={idx}
        categoryName={category.name}
        sortedLabels={sortedLabels.filter(label => label.type !== 'LABEL_TYPE_SWAN')}
        label={label}
        selected={selected}
      />
    )
  );

  return <Separator>{labelElements}</Separator>;
};
